import { createPostalCodesModule } from '@izimi/modules';

import { postalCodesApi } from '../di';

export const postalCodesModule = createPostalCodesModule({ postalCodesApi });
